import { StringPropertyViewModel, BoolPropertyViewModel, NumericPropertyViewModel, NNumericPropertyViewModel, BaseRowNumberItemViewModel } from '@nts/std';
import { ExpenseFile } from '../../domain-models/expense-file';
import { ExpenseFileIdentity } from '../../domain-models/expense-file.identity';

export class GeneratedExpenseFileCollectionItemViewModel extends BaseRowNumberItemViewModel<ExpenseFile, ExpenseFileIdentity> {

  private _originalFileName: StringPropertyViewModel;

  public get originalFileName(): StringPropertyViewModel {
    return this.getStringPropertyViewModel((value) => { this._originalFileName = value; }, this._originalFileName, 'originalFileName');
  }

  private _storageFileName: StringPropertyViewModel;

  public get storageFileName(): StringPropertyViewModel {
    return this.getStringPropertyViewModel((value) => { this._storageFileName = value; }, this._storageFileName, 'storageFileName');
  }

  private _serial: NumericPropertyViewModel<number>;

  public get serial(): NumericPropertyViewModel<number> {
    return this.getNumericPropertyViewModel<number>((value) => { this._serial = value; }, this._serial, 'serial');
  }

  private _attachmentFileId: NNumericPropertyViewModel<number>;

  public get attachmentFileId(): NNumericPropertyViewModel<number> {
    return this.getNNumericPropertyViewModel<number>((value) => { this._attachmentFileId = value; }, this._attachmentFileId, 'attachmentFileId');
  }

  private _fileSize: NumericPropertyViewModel<number>;

  public get fileSize(): NumericPropertyViewModel<number> {
    return this.getNumericPropertyViewModel<number>((value) => { this._fileSize = value; }, this._fileSize, 'fileSize');
  }

  private _isPrimaryFile: BoolPropertyViewModel;

  public get isPrimaryFile(): BoolPropertyViewModel {
    return this.getBoolPropertyViewModel({
      action: (value) => this._isPrimaryFile = value,
      value: this._isPrimaryFile,
      propertyName: 'isPrimaryFile'
    });
  }

}
